// extracted by mini-css-extract-plugin
export default {"terms_wrap":"SignTermsModal_terms_wrap__uRmrm"};